import * as React from 'react';
import { DATESYSTEM_TO_FORMAT } from '../../pages/subpages/Settings';
import { useAppStore } from '../../shared/stores/useAppStore';
import snakeToPascal from '../../tools';
import dayjs from "dayjs";

interface TimeSeriesRow {
    name: string;
    [date: string]: any;
}

const formatTimeSerieObj = (ts: any): TimeSeriesRow => {
    const ret: TimeSeriesRow = { name: ts.name };
    Object.entries(ts.value as Record<string, number>).forEach(([date, value]) => {
        ret[date] = value;
    });
    return ret;
};

const formatValue = (value: any): string => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'number') {
        return value.toLocaleString(useAppStore.getState().userSettings.numberFormattingLocale);
    }
    return String(value);
};

export default function AuditabilityDataTimeSeries({ used_data }: { used_data: any[] }) {
    const timeSeries = used_data.filter(data => data.type === 'time_serie');
    const timeSerieData = timeSeries.map(ts => formatTimeSerieObj(ts));

    if (timeSeries.length === 0) {
        return null;
    }

    // Get date columns (all keys except 'name')
    const dateColumns = Object.keys(timeSerieData[0]).filter(key => key !== 'name');

    return (
        <div className="mt-4 isolate">
            <div className="overflow-x-auto rounded-lg border border-slate-200">
                <table className="w-full text-sm border-collapse">
                    <thead>
                        <tr className="bg-slate-100">
                            <th className="px-3 py-2 text-left font-medium text-slate-700 sticky left-0 bg-slate-100 z-10 border-r border-slate-200 min-w-[150px]">
                                Name
                            </th>
                            {dateColumns.map(date => (
                                <th
                                    key={date}
                                    className="px-3 py-2 text-center font-medium text-slate-700 whitespace-nowrap min-w-[100px]"
                                >
                                    {dayjs(date).format(DATESYSTEM_TO_FORMAT[useAppStore.getState().userSettings.dateSystem])}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {timeSerieData.map((row, rowIndex) => (
                            <tr
                                key={row.name}
                                className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-slate-50'}
                            >
                                <td className="px-3 py-2 text-left font-medium text-slate-900 sticky left-0 z-10 bg-inherit border-r border-slate-200">
                                    {snakeToPascal(row.name)}
                                </td>
                                {dateColumns.map(date => (
                                    <td
                                        key={date}
                                        className="px-3 py-2 text-right tabular-nums text-slate-700 whitespace-nowrap"
                                    >
                                        {formatValue(row[date])}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
